<!-- AddNewLinkSidebar.vue -->
<template>
  <div>
    <b-modal
      id="add-new-link-sidebar"
      :visible="isAddNewLinkSidebarActive"
      size="lg"
      :title="popupTitle+ ' Paylaşım Oluşturucu'"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-link-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <type-selection
          v-if="!selectType && !editingLink"
          :selected-type="selectedType"
          @change-type="changeType"
        />
        <validation-observer v-else ref="refFormObserver" v-slot="{ handleSubmit }">
          <b class="d-block text-danger mb-1" v-if="selectedType!=3">
            Bu {{ typeData.id == 7 ? 'link' : 'paylaşım'}} {{ popupTitle }} türünde oluşturulacaktır.
          </b>
          <b-form-group
            label="Kısa Link"
            label-for="short_url"
            v-if="editingLink!=null && editingLink.short_url"
          >
            <b-input-group>
              <b-form-input
                id="link"
                v-model="linkData.short_url"
                :disabled="true"
                trim
              />
              <b-input-group-append>
                <b-button
                  variant="outline-success"
                  size="sm"
                  @click="$emit('copy-emit',linkData)"
                >
                  <feather-icon 
                    icon="CopyIcon"
                    title="Panoya Kopyala"
                    class="cursor-pointer" size="22"
                  ></feather-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>


          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
            id="linkForm"
          >
          
          <validation-provider
            #default="validationContext"
            :name="getTitleInput"
            rules="required|url"
          >
            <b-form-group
              :label="getTitleInput"
              label-for="link"
            >
              <b-input-group>
                <b-form-input
                  id="link"
                  v-model="linkData.link"
                  :disabled="editingLink!=null"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-input-group-append>
                  <b-button
                    v-if="editingLink!=null && !editingLink.group_id"
                    variant="outline-success"
                    @click="utmModal=true"
                  >
                    UTM Düzenle
                  </b-button>
                  <b-button variant="outline-primary" @click="linkControl" v-else-if="editingLink==null">
                    Link Kontrol
                  </b-button>
                </b-input-group-append>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </validation-provider>

            <b-card style="height:150px" v-if="tsoftInfoLoading">
              <div class="loading">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
              </div>
            </b-card>

            <b-card class="border" v-if="linkData.page_type && !tsoftInfoLoading">
              <b-form-group
                label="Paylaşım Türü"
                label-for="page_type"
                v-if="linkData.page_type"
              >
                <b-form-input
                  id="page_type"
                  v-model="linkData.page_type"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Ürün ID"
                label-for="product_id"
                v-if="linkData.page_type=='Ürün'"
              >
                <b-form-input
                  id="product_id"
                  v-model="linkData.product_id"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Kategori Id"
                label-for="category_id"
                v-if="linkData.page_type=='Kategori'"
              >
                <b-form-input
                  id="category_id"
                  v-model="linkData.category_id"
                  disabled
                />
              </b-form-group>
              <p class="text-danger">
                Bu alan otomatik gelmektedir. Link değişiminden sonra <b class="text-primary">Link Kontrol</b> butonuna basınız.
              </p>
            </b-card>

             <!-- Paylaşım Platform -->
              <validation-provider
              v-slot="validationContext"
              name="Platform"
              rules="required"
              :value="linkData.platform_id"
              v-if="typeData.id == 0 || typeData.id == 1 || typeData.model == 'bio'"
              >
              <b-form-group label="Platform">
                  <b-form-radio-group
                      v-model="linkData.platform_id"
                      :options="platformOptions"
                      :class="{'is-invalid' : validationContext.errors.length>0}"
                      name="platform_id"
                      :disabled="!!linkData.platform_id && platform"
                      :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </b-form-group>

             </validation-provider>
             <!-- Kategori Seçimi -->
            <validation-provider
              v-slot="validationContext"
              name="Grup Seçin"
              :value="linkData.group_id"
              v-if="typeData.use_category"
              >
              <b-form-group
                label="Grup Seçin (Opsiyonel)"
                label-for="group_id"
              >
              <v-select
                id="group_id"
                :options="categoriesOptions"
                v-model="linkData.group_id"
                :reduce="val => val.value"
                class="w-100"
                placeholder="Grup Seçin"
                @input="changeGroup"
                :clearable="false"
              />
                <small class="text-muted">
                  Sadece aktif gruplar seçilebilir.
                </small>
                  <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>


            <fenomen-share-form
              v-if="typeData.id === 0"
              :link-data="linkData"
              :selected-inf-ids="selectedInfIds"
              :fenomen-list="fenomenList"
              :editing-link="editingLink"
              :start-date="startDate"
              :end-date="endDate"
              @update="updateLinkData"
              @update-selected-inf-ids="updateSelectedInfIds"
            />
            <story-share-form
              v-if="typeData.id === 1"
              :link-data="linkData"
              @update="updateLinkData"
              @file-change="onFileChange"
            />
            <sms-share-form
              v-if="typeData.id === 2 || typeData.id === 4"
              :link-data="linkData"
              @update="updateLinkData"
              @edit-sms="smsEdit"
            />
            <bio-share-form
              v-if="typeData.model == 'bio'"
              :start-date="startDate"
              :end-date="endDate"
              :link-data="linkData"
              :type-data="typeData"
              @update="updateLinkData"
              :platformOptions="platformOptions"
            />
            <email-share-form
              v-if="typeData.id == 5"
              :link-data="linkData"
              :editing-link="editingLink"
              :start-date="startDate"
              :end-date="endDate"
              :platformOptions="platformOptions"
              @update="updateLinkData"
            />
            <web-push-share-form
              v-if="typeData.id == 6"
              :link-data="linkData"
              :editing-link="editingLink"
              :start-date="startDate"
              :end-date="endDate"
              :platformOptions="platformOptions"
              @update="updateLinkData"
            />
            <banner-share-form
              v-if="typeData.id == 7"
              :link-data="linkData"
              :editing-link="editingLink"
              :platformOptions="platformOptions"
              @update="updateLinkData"
              @file-change="onFileChange"
            />
          </b-form>
        </validation-observer>
      </template>
      <template #modal-footer="{ hide }">
        <div class="d-flex mt-2 justify-content-between col-12">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
            :disabled="addLoading"
          >
            Vazgeç
          </b-button>
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="bg-secondary"
              @click="selectedType=null;selectType=false"
              v-if="selectType && !editingLink && !type"
            >
              Önceki
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :disabled="!selectType || addLoading"
              class="ml-2"
              @click="$refs.refFormObserver.validate().then(success => { if (success) { onSubmit(); } })"
            >
              <b-spinner small v-if="addLoading" class="mr-1"/>
              {{ addLoading ? 'İşlem Yapılıyor...' : (editingLink ? 'Kaydet' : 'Ekle') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <set-utm-final
      :visible="utmModal"
      :utm-data="utmData"
      @close="utmModal = false"
      @copy-emit="$emit('copy-emit',$event)"
    />
    <sms-link-message
      v-if="showSmsContentModal"
      :show-sms-content-modal.sync="showSmsContentModal"
      :link="responseData"
    />
  </div>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormFile, BFormTextarea, BFormInvalidFeedback,
  BButton, BSpinner, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormDatepicker, BFormTimepicker, BCard, BRow, BCol,
  BFormRadioGroup,
  BFormRadio
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, computed, watch, onMounted  } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import SmsLinkMessage from './add/SmsLinkMessage.vue'
import TypeSelection from './add/TypeSelection.vue'
import FenomenShareForm from './add/FenomenShareForm.vue'
import StoryShareForm from './add/StoryShareForm.vue'
import BioShareForm from './add/BioShareForm.vue'
import SmsShareForm from './add/SmsShareForm.vue'
import EmailShareForm from './add/EmailShareForm.vue'
import WebPushShareForm from './add/WebPushShareForm.vue'
import BannerShareForm from './add/BannerShareForm.vue'
import setUtmFinal from './add/setUtmFinal.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import { useRouter } from '@core/utils/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { props } from 'vue-echarts'
import Swal from 'sweetalert2'
export default {
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormFile, BFormTextarea, BFormInvalidFeedback,
    BButton, BSpinner, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormDatepicker, BFormTimepicker, BCard, BRow, BCol,
    ValidationProvider, ValidationObserver,
    SmsLinkMessage, TypeSelection, FenomenShareForm, StoryShareForm, SmsShareForm, EmailShareForm, WebPushShareForm,BannerShareForm, vSelect, setUtmFinal, BioShareForm, BFormRadioGroup, BFormRadio
  },
  directives: {
    Ripple,
    Swal
  },
  props: {
    isAddNewLinkSidebarActive: { type: Boolean, required: true },
    editingLink: { type: Object, default: null },
    type: { type: Number, default: null },
    platform: { type: Number, default: null },
    fenomenList: { type: Array, default: () => [] },
    typeData: { type: Object, default: {categories: []} },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const selectType = ref(false)
    const selectedType = ref(null)
    const tsoftInfoLoading = ref(false)
    const addLoading = ref(false)
    const utmModal = ref(false)
    const utmData = ref ({})
    const platformOptions = ref ([])
    const startDate = ref({
      date: new Date().toISOString().substr(0, 10),
      hours: '00:00:00'
    })
    const endDate = ref({
      date: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().substr(0, 10),
      hours: '00:00:00'
    })
    const blankLink = {
      link: '',
      type: '',
      campaign_name: '',
      inf_id: null,
      product_id: null,
      category_id: null,
      page_type: null,
      link_ici_odeme_orani: null,
      link_disi_odeme_orani: null,
      start_date: null,
      end_date: null,
      status: null,
      description: null,
      image: null,
      link_type:[],
      platform_id:props.platform || null,
      short_code: null,
      payment_amount : null,
      group_id: null,
      is_internal_domain: 1
    }


    const selectedInfIds = ref([])
    const linkData = ref({ ...blankLink })
    const categoriesOptions = ref([])

    const baseUrl = store.state.user.customerInfo.domain;
    // SMS modal state
    const showSmsContentModal = ref(false)
    const responseData = ref({})
    const { route } = useRouter()
    if (props.type!=null) {
      changeType(props.type)
    }

    const popupTitle = computed(() => {
      let title = selectedType.value != null ? "FENOMEN" : ''
      switch (selectedType.value) {
        case 1: title = "STORY"; break;
        case 2: title = "SMS"; break;
        case 3: title = "BIO"; break;
        case 4: title = "WHATSAPP"; break;
        case 5: title = "EMAIL"; break;
        case 6: title = "WEB PUSH"; break;
        case 7: title = "BANNER"; break;
      }
      return title
    })

    // Watcher to clear category_id and product_id when link changes
    watch(() => linkData.value.link, (newLink, oldLink) => {
  try {
    const url = new URL(newLink);

    if (url.pathname.toLowerCase().includes('/arama')) {
      // T-Soft
      const qValue = url.searchParams.get('q');

      if (qValue) {
        url.search = '';
        url.searchParams.set('q', qValue);
      } else {
        // Ticimax
        const kelimeValue = url.searchParams.get('kelime');

        url.search = '';

        // ?1 gibi değeri olmayan parametreyi koru
        if (new URL(newLink).searchParams.has('1')) {
          url.searchParams.append('1', '');
        }

        if (kelimeValue) {
          url.searchParams.set('kelime', kelimeValue);
        }
      }
    } else {
      // Arama dışındaki sayfalarda tüm parametreleri temizle
      url.search = '';
    }

    linkData.value.link = url.origin + url.pathname + url.search;

  } catch (error) {
    console.error('Geçersiz URL:', error);
  }
});

      
    watch(() => props.editingLink, (newData) => {
      if (newData) {
        linkData.value = {...newData}
        utmData.value = linkData.value.short_data
        
        // Tek bir inf_id değerini bir diziye dönüştür
        selectedInfIds.value = Array.isArray(newData.inf_id) ? newData.inf_id : newData.inf_id ? [newData.inf_id] : [];
        selectedType.value = newData.type;
        selectType.value = true;

        if(selectedType.value==0 || selectedType==3){
          // startDate ve endDate boş olabilir, kontrol ekleyelim
          startDate.value = {
            date: newData.start_date ? newData.start_date.split(' ')[0] : '', // Eğer varsa ayır, yoksa boş string
            hours: newData.start_date ? newData.start_date.split(' ')[1] : '00:00:00' // Saat varsayılan 00:00:00
          };

          endDate.value = {
            date: newData.end_date ? newData.end_date.split(' ')[0] : '', 
            hours: newData.end_date ? newData.end_date.split(' ')[1] : '00:00:00'
          };
        }
        
      }
    });
    watch(() => utmModal.value, (newVal) => {
      if(!newVal){
        resetLinkData();
        emit('refetch-data');
        emit('update:is-add-new-link-sidebar-active', false);
      }
    })

    watch(() => showSmsContentModal.value, (newVal) => {
      if(!newVal){
        utmData.value = responseData.value.short_data
        utmModal.value=true
        responseData.value = {}
      }
      if(responseData.value){
        props.link=responseData.value
      }
    })

    watch(
      () => props.typeData,
      (newTypeData) => {
        const list = newTypeData?.categories || {}

        categoriesOptions.value = [
          { value: 0, label: '➕ Yeni Grup Ekle' },
          ...list.map(cat => ({
            value: cat.id,
            label: cat.campaign_name,
          }))
        ]
      },
      { immediate: true, deep: true }
    )

    function changeType(role) {
      linkData.value = { ...blankLink }
      if (role === 0) linkData.value.link_type = ['story'] // Default story olsun.
      selectedType.value = role
      if (role === 0) selectedInfIds.value = []
      else selectedInfIds.value = [1]
      selectType.value = true
    }

    function updateLinkData(data) {
      linkData.value = { ...linkData.value, ...data }
    }

    function updateSelectedInfIds(newData) {
      if (!props.fenomenList || !Array.isArray(props.fenomenList)) return;
  
      
      // Tümünü Seç/Kaldır işlemi
      if (newData.includes('all')) {
        // "all" seçeneğini listeden çıkar
        const withoutAll = newData.filter(id => id !== 'all');

        // Eğer tüm fenomenler zaten seçiliyse, tümünü kaldır
        if (withoutAll.length === props.fenomenList.length) {
          selectedInfIds.value = [];
        } else {
          // Tüm fenomenleri seç (sınırsız)
          selectedInfIds.value = props.fenomenList.map(opt => opt.value);
        }
        return;
      }

      // Birden fazla fenomen seçildiyse varsayılan oranları kullan
      if (newData.length > 1) {
        linkData.value.link_disi_odeme_orani = store.state.appConfig.defaultVat.disLink;
        linkData.value.link_ici_odeme_orani = store.state.appConfig.defaultVat.icLink;
      }

      // Tek fenomen seçildiğinde o fenomenin özel oranlarını kullan
      if (newData.length === 1) {
        const selectInf = props.fenomenList.find((item) => item.value === newData[0]);
        if (selectInf) {
          linkData.value.link_disi_odeme_orani = selectInf.link_disi_odeme_orani ?? linkData.value.link_disi_odeme_orani;
          linkData.value.link_ici_odeme_orani = selectInf.link_ici_odeme_orani ?? linkData.value.link_ici_odeme_orani;
          linkData.value.payment_amount = selectInf.payment_amount ?? linkData.value.payment_amount;
        }
      }
      selectedInfIds.value = newData

    }

    function smsEdit() {
      showSmsContentModal.value = true
      setTimeout(() => {
        responseData.value = { ...props.editingLink }
        responseData.value.editSms = true
      }, 150)
    }

    function resetLinkData() {
      emit('update-editing-link', null)
      utmData.value={}
      selectedType.value = null
      selectType.value = false
      selectedInfIds.value = []
      linkData.value = { ...blankLink }
      startDate.value = {
        date: new Date().toISOString().substr(0, 10),
        hours: '00:00:00'
      }
      endDate.value = {
        date: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().substr(0, 10),
        hours: '00:00:00'
      }
    }

    const onFileChange = (file) => {
      linkData.value.image = file
      console.log("linkData.value.image")
      console.log(linkData.value.image)
    }

    function getValidationState(context) {
      if (context) return context.validated ? !context.invalid : null
      return null
    }

    // Link kontrolü ve diğer işlemler (kodu uzatmamak için özetledim)
    const linkControl = async () => {
      if (!linkData.value.link) return;

      tsoftInfoLoading.value = true;

      // 1. URL baseUrl içermiyorsa (Harici link - örn: Google Maps)
      if (!linkData.value.link.includes(baseUrl)) {
        const result = await Swal.fire({
          title: 'Site Dışı Bağlantı',
          text: 'Girdiğiniz bağlantı ana sitenize ait değil. Siteniz haricinde paylaşım olarak kaydetmek istiyor musunuz?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Evet, Devam Et',
          cancelButtonText: 'Vazgeç',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          // Harici domain olarak işaretle
          linkData.value.is_internal_domain = 0;
          linkData.value.page_type = 'external'; // veya harici link tipiniz
        } else {
          // Vazgeçtiyse inputu sıfırla
          linkData.value.link = '';
          linkData.value.is_internal_domain = 1;
        }
        tsoftInfoLoading.value = false;
        return;
      }

      // 2. Kendi sitesine ait link (is_internal_domain = 1) -> T-Soft/Backend kontrolü
      linkData.value.is_internal_domain = 1;

      try {
        const response = await axiosIns.get('link/control?link=' + encodeURIComponent(linkData.value.link));
        
        linkData.value.product_id = response.data.product_id;
        linkData.value.category_id = response.data.category_id;
        linkData.value.page_type = response.data.page_type;
      } catch (error) {
        console.error("Error in link control:", error);
      } finally {
        tsoftInfoLoading.value = false;
      }
    };

    // Fonksiyon tarih ve saat bilgilerini birleştirir ve ISO formatına çevirir
    const formatDateTime = (date, time) => {
        const combinedDateTime = new Date(`${date}T${time}.000Z`);
        return combinedDateTime.toISOString(); // YYYY-MM-DDTHH:mm:ss.sssZ
      };

    const onSubmit = () => {

      if(selectedType.value==0){
        linkData.value.end_date = formatDateTime(endDate.value.date, endDate.value.hours);
      }

      if(selectedType.value==0){
        linkData.value.end_date = formatDateTime(endDate.value.date, endDate.value.hours);
      }
      if(selectedType.value==2 || selectedType.value==0 || selectedType.value==3){
        linkData.value.start_date = formatDateTime(startDate.value.date, startDate.value.hours);
      }
      
      // Fenomen seçimi kontrolü (Type 5 hariç)
      if (selectedType.value !== 5 && selectedInfIds.value.length === 0) {
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            icon: 'AlertTriangleIcon',
            variant: 'warning',
            title: 'Lütfen en az bir fenomen seçiniz',
          },
        })
        return
      }
      
      // Sayfa türü kontrolü
      if (!linkData.value.page_type) {
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            icon: 'AlertTriangleIcon',
            variant: 'warning',
            title: 'Link Kontrol ile sayfa bilgilerini alınız',
          },
        })
        return
      }
      
      if (addLoading.value) return; // Zaten loading durumundaysa tekrar çalıştırma
      addLoading.value=true
      // İstek için veri ve metod hazırla
      let requestData;
      let requestConfig = {};
      if (props.editingLink) {
        requestData = new FormData();

        for (const key in linkData.value) {
          const value = linkData.value[key];

          if (key === "image" && value instanceof File) {
            requestData.append("image", value);
          } else if (typeof value === "boolean") {
            // 🔥 true -> 1, false -> 0 olarak gönder
            requestData.append(key, value ? 1 : 0);
          } else if (Array.isArray(value)) {
            requestData.append(key, JSON.stringify(value));
          } else if (value !== undefined && value !== null) {
            requestData.append(key, value);
          }
        }

        if (selectedInfIds.value?.length > 0) {
          requestData.append("inf_ids", JSON.stringify(selectedInfIds.value));
        }

        if (selectedType.value !== null && selectedType.value !== undefined) {
          requestData.append("type", selectedType.value);
        }

        requestConfig.method = 'post'; 
        requestData.append("_method", "PUT"); // 🔥 önemli

      } else {
        // POST isteği için form-data
        requestData = new FormData();
        
        // linkData ekle (multi_link_id'yi group_id'ye çevir)
        for (const key in linkData.value) {
          const value = linkData.value[key];
          if (key === "image" && value instanceof File) {
            requestData.append("image", value);
          } else if (key === "multi_link_id" && value) {
            // multi_link_id'yi group_id olarak gönder
            requestData.append("group_id", value);
          } else if (Array.isArray(value)) {
            requestData.append(key, JSON.stringify(value));
          } else if (value !== undefined && value !== null && key !== "multi_link_id") {
            requestData.append(key, value);
          }
        }
        
        // Ek alanlar
        if (selectedInfIds.value?.length > 0) {
          requestData.append("inf_ids", JSON.stringify(selectedInfIds.value));
        }
        
        // Type 5 için fenomen gerekli değil, inf_id=1 otomatik backend'de ayarlanır
        
        if (selectedType.value !== null && selectedType.value !== undefined) {
          requestData.append("type", selectedType.value);
        }
        
        requestConfig.method = 'post';
      }

      // İsteği gönder
      axiosIns({
        url: '/link',
        data: requestData,
        ...requestConfig
      })
        .then((response) => {
          if (response.data.success) {
            
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CheckCircleIcon',
                variant: 'success',
                title: response.data.message,
              },
            });
            if (props.editingLink) {
                resetLinkData();
                emit('refetch-data');
                emit('update:is-add-new-link-sidebar-active', false);
                return;
            }

            if(selectedType.value == 2 || selectedType.value == 4){
              showSmsContentModal.value = true;
              setTimeout(() => {
                responseData.value = response.data.data
              }, 150);
            }else{
              if (response.data.group_id) {
                emit('update:multi-links', false);
                resetLinkData();
                emit('refetch-data');
                emit('update:is-add-new-link-sidebar-active', false);
              } else {        
                utmData.value = response.data.data.short_data
                utmModal.value = true
              }
            }
          } else {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'MailIcon',
                variant: 'warning',
                title: response.data.error,
              },
            });
            addLoading.value = false;
          }
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'InfoIcon',
              variant: 'warning',
              title: error.response.data.error || 'Bir hata oluştu',
            },
          });
        })
        .finally(() => {
          addLoading.value = false;
        });

    };

    const loadPlatforms = (response) => {
      try {
        platformOptions.value = response.map(platform => ({
          value: platform.id,
          text: platform.name,
          short_code: platform.short_code,
          default: platform.default,
          use_category: platform.use_category,
          categories: platform.categories || [] // 🔹 backend’den gelen kategorileri doğrudan al
        }))

        const defaultPlatform = platformOptions.value.find(p => p.default)
        if (defaultPlatform && !linkData.value.platform_id) {
          linkData.value.platform_id = defaultPlatform.value
          blankLink.platform_id = defaultPlatform.value
        }
      } catch (error) {
        console.error('Platformlar yüklenirken bir hata oluştu:', error)
      }

      updateLinkData()
    }

    const changeGroup = (selectedValue) => {
      if (selectedValue === 0) {
        emit('open-create-category') // 🔥 parent’a haber ver
        linkData.value.group_id = null
      } else {
        linkData.value.group_id = selectedValue
      }
    }

    const getTitleInput = computed(() => {
      switch (selectedType.value) {
        case 7: return "Banner Linki";
        default: return "Paylaşım Linki";
      }
    })

    onMounted(async () => {
      try {
        const response = await store.dispatch('settings/loadPlatforms')
        loadPlatforms(response)
      } catch (error) {
        console.error('Platform yükleme hatası:', error)
      }
    })

    const {
      refFormObserver,
      resetForm,
    } = formValidation(resetLinkData)

    return {
      selectType,
      selectedType,
      selectedInfIds,
      changeType,
      startDate,
      endDate,
      linkControl,
      linkData,
      onSubmit,
      refFormObserver,
      resetForm,
      resetLinkData,
      tsoftInfoLoading,
      addLoading,
      popupTitle,
      showSmsContentModal,
      smsEdit,
      platformOptions,
      responseData,
      updateLinkData,
      updateSelectedInfIds,
      onFileChange,
      getValidationState,
      utmModal,
      utmData,
      blankLink,
      categoriesOptions,
      changeGroup,
      getTitleInput
    }
  }
}
</script>